import * as React from "react";
import * as ReactDOM from "react-dom";

import "./styles/main.scss";

import { FrontPage, FrontPageState } from "./components/";
import { defaultLocation, defaultUser } from "./models";

const defaultState: FrontPageState = {
    loading: false,
    search: { ageFrom: 18, ageTo: 80, sexMale: false, sexFemale: false, location: defaultLocation },
    hero: Array(6).fill(defaultUser),
};

const container = document.getElementById("frontpage");
if (container !== null) {
    const stateAttribute = JSON.parse(container.getAttribute('data-initialState'));
    const props = JSON.parse(container.getAttribute('data-props'));

    const initialState = {
        ...defaultState,
        ...stateAttribute,
    };

    ReactDOM.render(
        <FrontPage initialState={initialState}
            searchAgeMin={props.searchAgeMin}
            searchAgeMax={props.searchAgeMax}
            onlineMembers={props.onlineMembers}
            onlineMembersLast7Days={props.onlineMembersLast7Days} />,
        document.getElementById("frontpage")
    );
}
